import botImage from 'images/nifty-orbit.svg';

export const docPermissions = () => {
    return [
        // {
        //     id: 'view',
        //     title: 'View'
        // },
        {
            id: 'comment',
            title: 'View & Comment'
        },
        {
            id: 'edit',
            title: 'View, Comment & Edit'
        }
    ]
}

export const teamPlans = () => {
    return [
        {
            key: 'X_Basic_Plan',
            id: 'X_Basic_Plan',
            name: 'Free',
            level: 0,
            price: {
                free: true,
                monthly: 0,
                annual: 0,
                perMember: true
            },
            description: 'Best to get you started.',
            features: [
                '2 Active Projects',
                '100 MB Space',
                'Unlimited Tasks'
            ],
            quota: {
                storageBytes: 104857600,
                clients: 0,
                projects: 2,
                fileBytes: 26214400
            },
            show: true
        },
        {
            key: 'X_Level_10_2021_PS',
            id: 'X_Level_10_2021_PS',
            name: 'Starter',
            level: 10,
            price: {
                monthly: 9,
                annual: 5,
                annualDiscount: .45,
                perMember: true
            },
            description: 'Includes all the core features.',
            features: [
                '40 Active Projects',
                '100 GB Space',
                'Time Tracking & Reporting',
                'Project Portfolios',
                'Custom Fields',
                'Unlimited Guests'
            ],
            quota: {
                storageBytes: 1073741824 * 100,
                projects: 40,
            },
            show: false
        },
        {
            key: 'X_Level_10_2021A_PS',
            id: 'X_Level_10_2021A_PS',
            name: 'Starter',
            level: 10,
            price: {
                monthly: 9,
                annual: 5,
                annualDiscount: .45,
                perMember: true
            },
            description: 'Includes all the core features.',
            features: [
                '40 Active Projects',
                '100 GB Space',
                'Time Tracking & Reporting',
                'Project Portfolios',
                'Custom Fields',
                'Unlimited Guests'
            ],
            quota: {
                storageBytes: 1073741824 * 100,
                projects: 40,
            },
            show: true
        },
        {
            key: 'X_Level_20_2021_PS',
            id: 'X_Level_20_2021_PS',
            name: 'Pro',
            level: 20,
            featured: true,
            price: {
                monthly: 16,
                annual: 10,
                annualDiscount: .35,
                perMember: true
            },
            description: 'All the essential and pro features.',
            features: [
                '100 Active Projects',
                '250 GB Space',
                'Everything in Starter plus',
                'Google SSO',
                'Cross-Project Overviews',
                'Workflow Automations',
            ],
            quota: {
                storageBytes: 1073741824 * 250,
                projects: 100,
            },
            show: true
        },
        {
            key: 'X_Level_30_2021_PS',
            id: 'X_Level_30_2021_PS',
            name: 'Business',
            level: 30,
            price: {
                monthly: 25,
                annual: 16,
                annualDiscount: .35,
                perMember: true
            },
            description: 'Best for ultimate team productivity.',
            features: [
                'Unlimited Projects',
                'Unlimited Space',
                'Everything in Pro plus',
                'Team Workloads + Reports',
                'Custom Roles & Permissions',
                'Microsoft SSO',
            ],
            quota: {
                storageBytes: 1073741824 * 1024
            },
            show: true
        },
        {
            key: 'X_Starter',
            id: 'X_Starter',
            name: 'Starter',
            level: 10,
            price: {
                monthly: 49,
                annual: 39,
                annualDiscount: .2,
            },
            description: 'Includes all the core features.',
            features: [
                'Up to 10 Members',
                '40 Active Projects',
                '100 GB Space',
                'Unlimited Guests & Clients',
                'Time Tracking & Reporting',
                'Project Portfolios',
                'Custom Fields'
            ],
            quota: {
                storageBytes: 1073741824 * 100,
                members: 10,
                projects: 40
            },
            show: true
        },
        {
            key: 'X_Pro',
            id: 'X_Pro',
            name: 'Pro',
            featured: true,
            level: 20,
            price: {
                monthly: 99,
                annual: 79,
                annualDiscount: .2,
            },
            description: 'All the essential and pro features.',
            features: [
                'Up to 20 Members',
                'Unlimited Projects',
                '500 GB Space',
                'Everything in Starter plus',
                'Cross-Project Overviews',
                'Workflow Automations',
                'Google SSO',
            ],
            quota: {
                storageBytes: 1073741824 * 500,
                members: 20
            },
            show: true
        },
        {
            key: 'X_Business',
            id: 'X_Business',
            name: 'Business',
            level: 30,
            price: {
                monthly: 149,
                annual: 124,
                annualDiscount: .2,
            },
            description: 'Best for ultimate team productivity.',
            features: [
                'Up to 50 Members',
                'Unlimited Projects',
                '1 TB Space',
                'Everything in Pro plus',
                'Team Workloads + Reports',
                'Custom Permissions',
                'Microsoft SSO',
            ],
            quota: {
                storageBytes: 1073741824 * 1024,
                members: 50
            },
            show: true
        },
        {
            key: 'X_Educational',
            id: 'X_Educational',
            name: 'Special',
            level: 40,
            price: {
                monthly: 0,
                annual: 0,
                perMember: true
            },
            description: 'Best for smaller and medium-sized teams.',
            features: [
                'Unlimited Projects',
                'Unlimited Guests',
                '5 GB Space / Member',
                'Time Tracking & Reporting',
                'Custom Fields',
                'Google SSO',
                'Priority Support'
            ],
            quota: {
                storageBytes: 1073741824 * 1024
            },
            show: false
        },
        {
            key: 'X_Enterprise',
            id: 'X_Enterprise',
            name: 'Enterprise',
            level: 50,
            price: {
                // contact: true
                monthly: 499,
                annual: 399,
                annualDiscount: .2,
            },
            description: 'A fully customizable solution.',
            features: [
                'Unlimited Members',
                'Unlimited Space',
                'Everything in Business plus',
                'Dedicated Account Manager',
                'Personalized Onboarding',
                'Custom SAML/SSO Support',
                'Open API',
            ],
            quota: {
                storageBytes: 1073741824 * 2048
            },
            show: true
        },
        {
            key: 'App_Sumo_1',
            id: 'App_Sumo_1',
            name: 'AppSumo 1',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 100,
                members: 3
            },
            show: false
        },
        {
            key: 'App_Sumo_2',
            id: 'App_Sumo_2',
            name: 'AppSumo 2',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 200,
                members: 6
            },
            show: false
        },
        {
            key: 'App_Sumo_3',
            id: 'App_Sumo_3',
            name: 'AppSumo 3',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 500,
                members: 9
            },
            show: false
        },
        {
            key: 'App_Sumo_4',
            id: 'App_Sumo_4',
            name: 'AppSumo 4',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 600,
                members: 12
            },
            show: false
        },
        {
            key: 'App_Sumo_5',
            id: 'App_Sumo_5',
            name: 'AppSumo 5',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1024,
                members: 15
            },
            show: false
        },
        {
            key: 'App_Sumo_6',
            id: 'App_Sumo_6',
            name: 'AppSumo 6',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1229,
                members: 18
            },
            show: false
        },
        {
            key: 'App_Sumo_7',
            id: 'App_Sumo_7',
            name: 'AppSumo 7',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1434,
                members: 21
            },
            show: false
        },
        {
            key: 'App_Sumo_8',
            id: 'App_Sumo_8',
            name: 'AppSumo 8',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1639,
                members: 24
            },
            show: false
        },
        {
            key: 'App_Sumo_9',
            id: 'App_Sumo_9',
            name: 'AppSumo 9',
            appSumo: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 1844,
                members: 27
            },
            show: false
        },
        {
            key: 'App_Sumo_10',
            id: 'App_Sumo_10',
            name: 'AppSumo 10',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 30
            },
            show: false
        },
        {
            key: 'App_Sumo_11',
            id: 'App_Sumo_11',
            name: 'AppSumo 11',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 33
            },
            show: false
        },
        {
            key: 'App_Sumo_12',
            id: 'App_Sumo_12',
            name: 'AppSumo 12',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 36
            },
            show: false
        },
        {
            key: 'App_Sumo_13',
            id: 'App_Sumo_13',
            name: 'AppSumo 13',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 39
            },
            show: false
        },
        {
            key: 'App_Sumo_14',
            id: 'App_Sumo_14',
            name: 'AppSumo 14',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 42
            },
            show: false
        },
        {
            key: 'App_Sumo_15',
            id: 'App_Sumo_15',
            name: 'AppSumo 15',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 45
            },
            show: false
        },
        {
            key: 'App_Sumo_16',
            id: 'App_Sumo_16',
            name: 'AppSumo 16',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 48
            },
            show: false
        },
        {
            key: 'App_Sumo_17',
            id: 'App_Sumo_17',
            name: 'AppSumo 17',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 51
            },
            show: false
        },
        {
            key: 'App_Sumo_18',
            id: 'App_Sumo_18',
            name: 'AppSumo 18',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 54
            },
            show: false
        },
        {
            key: 'App_Sumo_19',
            id: 'App_Sumo_19',
            name: 'AppSumo 19',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 57
            },
            show: false
        },
        {
            key: 'App_Sumo_20',
            id: 'App_Sumo_20',
            name: 'AppSumo 20',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 60
            },
            show: false
        },
        {
            key: 'App_Sumo_25',
            id: 'App_Sumo_25',
            name: 'AppSumo 25',
            appSumo: true,
            appSumoMax: true,
            price: {
                free: true,
                monthly: 0,
                annual: 0
            },
            quota: {
                storageBytes: 1073741824 * 2048,
                members: 75
            },
            show: false
        },
        {
            key: 'X_Lifetime_1',
            id: 'X_Lifetime_1',
            name: 'Lifetime',
            quota: {
                members: 5,
                storageBytes: 1073741824 * 50,
            },
            price: {
                lifetime: 149
            }
        },
        {
            key: 'X_Lifetime_2',
            id: 'X_Lifetime_2',
            name: 'Lifetime',
            quota: {
                members: 10,
                storageBytes: 1073741824 * 100,
            },
            price: {
                lifetime: 299
            }
        },
        {
            key: 'X_Lifetime_3',
            id: 'X_Lifetime_3',
            name: 'Lifetime',
            quota: {
                members: 15,
                storageBytes: 1073741824 * 150,
            },
            price: {
                lifetime: 449
            }
        },
        {
            key: 'X_Lifetime_4',
            id: 'X_Lifetime_4',
            name: 'Lifetime',
            quota: {
                members: 20,
                storageBytes: 1073741824 * 200,
            },
            price: {
                lifetime: 599
            }
        },
        {
            key: 'X_Lifetime_5',
            id: 'X_Lifetime_5',
            name: 'Lifetime',
            quota: {
                members: 25,
                storageBytes: 1073741824 * 250,
            },
            price: {
                lifetime: 749
            }
        },
        {
            key: 'X_Lifetime_6',
            id: 'X_Lifetime_6',
            name: 'Lifetime',
            quota: {
                members: 30,
                storageBytes: 1073741824 * 300,
            },
            price: {
                lifetime: 899
            }
        },
        {
            key: 'X_Lifetime_7',
            id: 'X_Lifetime_7',
            name: 'Lifetime',
            quota: {
                members: 40,
                storageBytes: 1073741824 * 400,
            },
            price: {
                lifetime: 1199
            }
        },
        {
            key: 'X_Lifetime_8',
            id: 'X_Lifetime_8',
            name: 'Lifetime',
            quota: {
                members: 50,
                storageBytes: 1073741824 * 500,
            },
            price: {
                lifetime: 1499
            }
        },
        {
            key: 'X_Lifetime_9',
            id: 'X_Lifetime_9',
            name: 'Lifetime',
            quota: {
                members: 100,
                storageBytes: 1073741824 * 1024,
            },
            price: {
                lifetime: 2999
            }
        },
        {
            key: 'X_Lifetime_10',
            id: 'X_Lifetime_10',
            name: 'Lifetime',
            quota: {
                // members: 40,
                storageBytes: 1073741824 * 1024 * 5,
            },
            price: {
                lifetime: 4999
            }
        }
    ];
}

export const FILE_GROUPS = [
    {
        id: 'all',
        title: 'All Files',
        icon: 'ion-file',
        types: []
    },
    {
        id: 'images',
        title: 'Images',
        icon: 'ion-android-image',
        types: ['jpg', 'jpeg', 'gif', 'png', 'tif', 'tiff']
    },
    {
        id: 'documents',
        title: 'Documents',
        icon: 'ion-android-document',
        types: ['doc', 'docx', 'otf', 'txt', 'pdf']
    },
    {
        id: 'presentations',
        title: 'Presentations',
        icon: 'slideshow',
        types: ['ppt', 'pptx']
    },
    {
        id: 'spreadsheets',
        title: 'Spreadsheets',
        icon: 'border_all',
        types: ['xls', 'xlsx', 'csv']
    },
    {
        id: 'video',
        title: 'Video',
        icon: 'play_arrow',
        types: ['mp4', 'webm', 'avi', 'mov']
    },
    {
        id: 'audio',
        title: 'Audio',
        icon: 'audiotrack',
        types: ['aac', 'm4a', 'mp3']
    },
    {
        id: 'code',
        title: 'Code',
        icon: 'code',
        types: ['html', 'json', 'java', 'css', 'php', 'js']
    },
    {
        id: 'designs',
        title: 'Designs',
        icon: 'brightness_high',
        types: ['ai', 'psd', 'sketch']
    },
    {
        id: 'other',
        title: 'Other',
        icon: 'more_horiz',
        types: ['tar', 'tgz', 'key', 'epub', 'rar', 'xmal', 'zip', 'ttf']
    }
];

export const BOT = {
    name: 'Nifty Orbit',
    image: botImage
};

export const COLORS = {
    '#02bdad': {
        primary: '#02bdad',
        secondary: '#00a99b',
        text: '#fff',
        selectable: true
    },
    '#feae4c': {
        primary: '#feae4c',
        secondary: '#ff8e42',
        text: '#000',
        selectable: true
    },
    '#df67ff': {
        primary: '#df67ff',
        secondary: '#c44ae4',
        text: '#fff',
        selectable: true
    },
    '#626262': {
        primary: '#626262',
        secondary: '#2f2f2f',
        text: '#fff',
        selectable: true
    },
    '#ffcc34': {
        primary: '#ffcc34',
        secondary: '#f6b800',
        text: '#000',
        selectable: true
    },
    '#ff735f': {
        primary: '#ff735f',
        secondary: '#ff5a43',
        text: '#fff',
        selectable: true
    },
    '#8dd7ff': {
        primary: '#8dd7ff',
        secondary: '#5cc0f5',
        text: '#fff',
        selectable: true
    },
    '#efefef': {
        primary: '#efefef',
        secondary: '#dfdfdf',
        text: '#000',
        selectable: true
    },
    '#20f0c5': {
        primary: '#20f0c5',
        secondary: '#03cea4',
        text: '#fff',
        selectable: true
    },
    '#9780ff': {
        primary: '#9780ff',
        secondary: '#512df6',
        text: '#fff',
        selectable: true
    },
    '#031a6b': {
        primary: '#031a6b',
        secondary: '#3752af',
        text: '#fff',
        selectable: true
    },
    '#7527d3': {
        primary: '#7527d3',
        secondary: '#5d03bd',
        text: '#fff',
        selectable: true
    },
    '#5db4ff': {
        primary: '#5db4ff',
        secondary: '#0089ff',
        text: '#fff',
        selectable: true
    },
    '#ff81be': {
        primary: '#ff81be',
        secondary: '#ff278f',
        text: '#fff',
        selectable: true
    },
    '#dd8d31': {
        primary: '#dd8d31',
        secondary: '#a75f0c',
        text: '#fff',
        selectable: true
    },
    '#f1f7fd': {
        primary: '#f1f7fd',
        secondary: '#d7e4ef',
        text: '#000',
        selectable: true
    },
    '#fff4f4': {
        primary: '#fff4f4',
        secondary: '#fededf',
        text: '#000',
        selectable: true
    },
    '#fffaee': {
        primary: '#fffaee',
        secondary: '#efe5ce',
        text: '#000',
        selectable: true
    },
    '#cecece': {
        primary: '#cecece',
        secondary: '#a2a2a2',
        text: '#000',
        selectable: true
    },
    '#ffee7e': {
        primary: '#ffee7e',
        secondary: '#ffe01a',
        text: '#000',
        selectable: true
    },
    '#ffc107': {
        primary: '#ffc107',
        secondary: '#f6b800',
        text: '#000',
        selectable: false
    },
    '#f9a33a': {
        primary: '#f9a33a',
        secondary: '#ff8e42',
        text: '#000',
        selectable: false
    },
    '#fc93ae': {
        primary: '#fc93ae',
        secondary: '#e27390',
        text: '#fff',
        selectable: false
    },
    '#2ad7d5': {
        primary: '#2ad7d5',
        secondary: '#2db5b3',
        text: '#fff',
        selectable: false
    }
};

export const DEFAULT_SIGNUP_PLAN = 'X_Business_Monthly';

export const DEFAULT_FREE_PLAN = 'X_Basic_Plan';

export const DEFAULT_THEME = 'light';

export const DEFAULT_PROJECT_ROUTE = 'home';

export const CREATE_PROJECT_ON_TEAM_CREATE = false;

export const DEFAULT_ROUTE = '/dashboard';
export const DEFAULT_LOGIN_ROUTE = '/my/tasks';

export const ARCHIVED_TASK_GROUP = {
    id: 'archived',
    name: 'Archived',
    static: true,
    pseudo: true,
    type: 'archived',
    order: 999999
};

export const COMPLETED_TASK_GROUP = {
    id: 'completed',
    name: 'Completed',
    static: true,
    pseudo: true,
    type: 'completed',
    order: 999998
};

export const DEFAULT_TASKS_VIEW = 'kanban';
